import { useCallback, useEffect, useId, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import promoBanner from '../images/promo/modalidad-satelite-promo.png';
import '../styles/HomeNovedadesBubble.css';

function HomeNovedadesBubble() {
  const titleId = useId();
  const [panelOpen, setPanelOpen] = useState(false);
  const innerRef = useRef(null);

  const closePanel = useCallback(() => setPanelOpen(false), []);

  useEffect(() => {
    if (!panelOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closePanel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [panelOpen, closePanel]);

  useEffect(() => {
    if (!panelOpen) return undefined;
    const onDown = (e) => {
      if (innerRef.current && !innerRef.current.contains(e.target)) {
        closePanel();
      }
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [panelOpen, closePanel]);

  const onTrackClick = (e) => {
    if (e.target.closest('a[href]')) return;
    setPanelOpen((v) => !v);
  };

  const onTrackKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setPanelOpen((v) => !v);
    }
  };

  return (
    <aside className="tm-home-promo" aria-label="Novedades TM Studio">
      <div ref={innerRef} className="tm-home-promo-inner">
        {panelOpen && (
          <div
            className="tm-home-promo-panel"
            role="dialog"
            aria-modal="true"
            aria-labelledby={titleId}
          >
            <button type="button" className="tm-home-promo-panel-close" aria-label="Cerrar" onClick={closePanel}>
              <span className="material-symbols-outlined" aria-hidden>
                close
              </span>
            </button>
            <div className="tm-home-promo-panel-visual">
              <img
                src={promoBanner}
                alt="Con la modalidad satélite de TMStudio: No hay fronteras. Lo esencial de la modalidad satélite."
                className="tm-home-promo-panel-img"
                loading="lazy"
              />
            </div>
            <div className="tm-home-promo-panel-copy">
              <h2 id={titleId} className="tm-home-promo-panel-title">
                Lo esencial de la modalidad satélite
              </h2>
              <p className="tm-home-promo-panel-text">
                Conoce si es para ti, qué incluye el acompañamiento y cómo agendar tu entrevista desde donde estés.
              </p>
              <div className="tm-home-promo-panel-actions">
                <Link
                  to="/modalidad-satelite"
                  className="tm-home-promo-panel-btn tm-home-promo-panel-btn--primary"
                  onClick={closePanel}
                >
                  Conocer modalidad
                </Link>
                <Link to="/registro" className="tm-home-promo-panel-btn tm-home-promo-panel-btn--ghost" onClick={closePanel}>
                  Ir a registro
                </Link>
              </div>
            </div>
          </div>
        )}

        <div
          className="tm-home-promo-track"
          role="button"
          tabIndex={0}
          onClick={onTrackClick}
          onKeyDown={onTrackKeyDown}
          aria-expanded={panelOpen}
          aria-label="Novedades TM Studio — Modalidad satélite"
        >
          <span className="tm-home-promo-pill-wave" aria-hidden>
            <span className="tm-home-promo-wave-ring" />
            <span className="tm-home-promo-wave-ring" />
            <span className="tm-home-promo-wave-ring" />
            <span className="tm-home-promo-pill">
              <span className="material-symbols-outlined tm-home-promo-pill-icon">satellite_alt</span>
            </span>
          </span>
        </div>
      </div>
    </aside>
  );
}

export default HomeNovedadesBubble;
